export default {
  mounted(el, binding) {
    // If we're already intersecting, don't do anything (optional, depends on use case)
    // binding.value should be a function that sets a "isVisible" ref to true
    
    const options = {
      root: null,
      rootMargin: '200px', // Start rendering 200px before it comes into view
      threshold: 0.1
    }

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (typeof binding.value === 'function') {
            binding.value()
          }
          // Stop observing once visible
          observer.unobserve(el)
        }
      })
    }, options)

    observer.observe(el)
    el._observer = observer
  },
  unmounted(el) {
    if (el._observer) {
      el._observer.disconnect()
    }
  }
}
